import { useEffect, useState } from "react";
import { styled, Button } from "@mui/material";
import plusIcon from "../icons/plusIcon.svg";
import { nFormatter } from "../../utils/parseNumber";
import colors from "../../theme/themeConstants";

interface IProps {
  tags: any[];
  expanded?: boolean;
  showAmount?: boolean;
  setTags: (tags: any) => void;
  mainSelectedTags: string[];
  invertColor?: boolean;
}

const PAGE_SIZE = 30;

const SelectTags = ({ tags, expanded, showAmount, setTags, mainSelectedTags, invertColor }: IProps) => {

  const [page, setPage] = useState(1);
  const [paginatedTags, setPaginatedTags] = useState<any>([]);

  const amountOfShrinkedTags = PAGE_SIZE * page;

  const [selectedTags, setSelectedTags] = useState<string[]>(mainSelectedTags !== null ? mainSelectedTags : []);

  const handleTagClick = (tag: any) => (event: React.MouseEvent) => {
    event.stopPropagation();
    let tagText = tag.name;
    if (showAmount && tag.name) {
      tagText = tag.name;
    }

    if (tagText !== null) {
      let existIndex = null;
      const newSelectedTags = [...selectedTags];

      newSelectedTags.forEach((el, index) => {
        if (el === tagText) {
          existIndex = index;
        }
      });

      if (existIndex !== null) {
        newSelectedTags.splice(existIndex, 1);
      } else {
        newSelectedTags.push(tagText);
      }

      setSelectedTags(newSelectedTags);
      setTags(newSelectedTags);
    } else {
      // eslint-disable-next-line
      console.warn("Oops, an empty tag clicked.");
    }
  };

  const onMoreClick = () => {
    setPage(page + 1);
  };

  const sortSelected = (tags: any) => {
    const newPaginated = [...tags];

    newPaginated.sort((el: any) => {
      let isExist = false;

      selectedTags.forEach(tag => {
        if (tag === el.name) {
          isExist = true;
        }
      });

      return isExist ? -1 : 0;
    });

    setPaginatedTags(newPaginated);
  };

  useEffect(() => {
    if (tags) {
      const newTags = tags.slice(0, PAGE_SIZE * page);
      sortSelected(newTags);
    }
    // eslint-disable-next-line
  }, [page, tags])

  useEffect(() => {
    sortSelected(paginatedTags);
    // eslint-disable-next-line
  }, [selectedTags])

  useEffect(() => {
    onMoreClick();
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    sortSelected(paginatedTags);
    // eslint-disable-next-line
  }, [paginatedTags.length])

  return (
    <Container id="tagsblock" isExpanded={Boolean(expanded)} >
      {(tags && tags.length > 0) ? paginatedTags?.map((tag: any, index: number) =>
        <Button
          onClick={handleTagClick(tag)}
          sx={{
            background: selectedTags.find((el: any) => el === tag.name) ? colors.redPink : "transparent",
            color: invertColor ? (selectedTags.find((el: any) => el === tag.name) ? colors.white : colors.textDark) : colors.white,
            display: `${index < amountOfShrinkedTags ? "inline-block" : "none"}`,
            textShadow: invertColor ? "none" : "black 1px 0 5px",
            whiteSpace: "nowrap",
          }}
          key={index}
        >
          {showAmount ? <span>{tag.name}{showAmount ? <p
            style={{
              opacity: 0.6,
              display: "inline",
              marginLeft: "3px",
              // eslint-disable-next-line no-magic-numbers
            }}>{nFormatter(tag.count)}</p> : null}</span>
            : tag.name}
        </Button>
      ) : <p style={{ fontSize: "14px" }}>We have some issues with loading tags. Please close and open the dialog and try again.</p>}
      {tags.length > 3 && !expanded ?
        <Button
          sx={{
            minWidth: "2.5rem !important",
            minHeight: "2.5rem !important",
            padding: "0 !important",
            background: colors.redPink,
            color: colors.white,
          }}
          onClick={onMoreClick}>
          <img src={plusIcon} alt="More tags" style={{ maxWidth: "16px" }} />
        </Button> : null}
    </Container>
  );
};

const Container = styled("div", { shouldForwardProp: (prop) => prop !== "isExpanded" }
)<{ isExpanded: boolean }>(({ isExpanded }) => {
  return {
    marginTop: "1rem",
    display: "flex",
    flexWrap: "wrap",
    "> button": {
      marginRight: "0.5rem",
      padding: "7px 12px",
      borderRadius: "24px",
      minWidth: "3rem",
      maxWidth: "10rem",
      width: "auto",
      marginBottom: "0.5rem",
      fontSize: "12px",
      border: `1px solid ${colors.redPink}`,
      "&:hover": {
        background: colors.selectedCollectionItem,
        opacity: 0.8
      }
    }
  };
});

export default SelectTags;
